import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";
import CGridstack from 'components/CGridstack';

import {
    TabPane, Row
} from "reactstrap";

export default function TabFrag(props) {
    const { data, modelFctManager, parentProps, isConfiguration, childShouldRerender, parentDisabled, tabIndex } = props;

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [shouldRender, setShouldRender] = React.useState(false);


    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        //if ((!data.categories || data.categories.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);

    React.useEffect(() => {
        parentProps?.parentData?.functionManager?.rerender();
    }, [shouldRender]);


    //useEffect sur props pour trigger APRES le render du composant
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getChilds = () => { return data.categories; };
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = (forceChild) => {
        setShouldRender(!shouldRender);
        if (forceChild) {
            data.categories.forEach((child) => {
                child?.functionManager?.rerender(true);
            });
        }
    };

    var childs = [];
    if (data.categories) {
        childs = data.categories.map((child) => {
            var childRender = modelFctManager.componentTyped(child, { parentData: data, childs: data.categories, parentDisabled: (parentDisabled || data.disabled ? true : false) });

            if (isConfiguration && !child.gridWidth) {
                var design = child.mergedDesign || child.customDesign?.design;
                var wSize = 1;
                if (design) {
                    wSize = design.boxSize || 1;
                }
                child.gridWidth = Math.round(parseFloat(wSize) * 12);
            }
            return childRender;
        });
    }
    data.childCount = childs.length;

    var frameClass = "";
    var rowClass = "";
    var frameStyle = { minHeight: "50px" };
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }
    if (data.disabled) frameClass += " form-disabled";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_template");
    data.mergedDesign = design;
    if (design) {
        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));


        if (design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) frameStyle.width = design.width;
            else {
                frameClass += " w-100";
            }
            frameStyle.overflowX = "hidden";//auto
            //frameClass += " m-0";
        }
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) frameStyle.minHeight = design.height;
            else {
                frameClass += " h-100";
                rowClass += " h-100";
                modelFctManager.setParentFullHeight();
            }
            frameStyle.overflowY = "hidden";//auto
            //frameClass += " m-0";
        }

    }

    //designInput géré sur ReportTabFrag

    
    if (isConfiguration && !data.gridID) data.gridID = Math.floor(Math.random() * 1000000000);

    //return <div data-name="TabFrag" data-element={data.objType} className={`row ${frameClass}`}>{childs}</div>;
    return isConfiguration ? <TabPane data-name="TabFrag" data-element={data.objType} className={`${frameClass}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null} tabId={tabIndex.toString()} tab-index={tabIndex.toString()}>
        <CGridstack data={childs.map((child, index) => {
            var width = 12;
            var item;
            if (data.categories) {
                item = data.categories[index];
                if (item && item.gridWidth) width = item.gridWidth;
            }
            return { children: child, id: "category-" + data.gridID + "-" + (item?.key || index), srcData: item, noCard: true, x: (index > 0 ? width : 0), y: index * 5, w: width/*, h: 5*/, sizeToContent: true };
        })} type={"template"} srcData={data} configModel={null} isConfigurationMode={true} withRemove={true} noOneColumn={true} defaultState={true} className="" target={`grid-stack-template-${data.gridID}`} gridClass={"grid-stack-nested"} actionsClass={"text-secondary"} gridOpts={{ cellHeight: 50, sizeToContent: true, acceptWidgets: ".grid-category, .grid-stack-template > .grid-stack-item" }} triggerClick={(grid, dataItem) => { modelFctManager.setSelected(grid, dataItem); }}
            onDropped={(event, prevNode, n) => {
                modelFctManager.dropManager(data, event, prevNode, n);
                setShouldRender(!shouldRender);
            }} />
    </TabPane>
        : <TabPane data-name="TabFrag" data-element={data.objType} className={`${frameClass}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null} tabId={tabIndex.toString()} tab-index={tabIndex.toString()}><Row className={`${rowClass}`}>{childs}</Row></TabPane>;
}